/**
 * Tab navigation for different game views
 * Stacked icon + label layout optimized for mobile touch targets
 */

import { useCurrentTab, useGameStore } from '@/state';

export const tabs = [
  { id: 'fishing' as const, label: 'Fish', icon: '🎣' },
  { id: 'inventory' as const, label: 'Items', icon: '📦' },
  { id: 'outfitters' as const, label: 'Shop', icon: '🏪' },
  { id: 'markets' as const, label: 'Market', icon: '🍽️' },
  { id: 'buddies' as const, label: 'Buddies', icon: '🧑‍🤝‍🧑' },
  { id: 'stats' as const, label: 'Stats', icon: '📊' },
  { id: 'milestones' as const, label: 'Milestones', icon: '🏆' },
];

export const TAB_IDS = tabs.map((t) => t.id);

export function TabNavigation() {
  const currentTab = useCurrentTab();
  const setCurrentTab = useGameStore((state) => state.setCurrentTab);

  return (
    <nav className="bg-surface-base border-t border-border-default shrink-0 safe-area-bottom" role="tablist">
      <div className="flex">
        {tabs.map((tab) => {
          const isActive = currentTab === tab.id;
          return (
            <button
              key={tab.id}
              role="tab"
              aria-selected={isActive}
              onClick={() => setCurrentTab(tab.id)}
              className={`
                flex-1 flex flex-col items-center justify-center
                py-3 min-h-[56px] relative
                transition-colors duration-150
                ${
                  isActive
                    ? 'text-blue-400'
                    : 'text-gray-500 hover:text-gray-300 active:text-gray-200 active:bg-gray-800'
                }
              `}
            >
              {isActive && (
                <span className="absolute top-0 left-2 right-2 h-[2px] bg-blue-400 rounded-b" />
              )}
              <span className="text-xl leading-none">{tab.icon}</span>
              <span className={`text-[10px] mt-1 font-medium tracking-wide ${isActive ? 'text-blue-400' : ''}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
